import type { reducer } from './fhhActions';

export const fhhDefaultState = {
    destination: '',
    destinationData: null,
    startDate: null,
    endDate: null,
    numOfBedrooms: 0,
    numOfBeds: 0,
};

export type FhhState = ReturnType<typeof reducer>;
